import { motion } from "framer-motion";
import { ArrowDown } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";
import { scrollToSection } from "@/components/SmoothScroll";
import Reveal from "@/components/Reveal";

const Pricing = () => {
  const { t } = useLanguage();

  return (
    <section id="preturi" data-testid="section-pricing" className="px-6 py-12 md:py-16">
      <Reveal className="mx-auto max-w-6xl">
        <div className="relative overflow-hidden rounded-[2.5rem] bg-[#1A1A1A] p-10 text-[#FDFBF7] md:p-16">
          <span className="absolute inset-x-0 top-0 h-1 bg-gradient-to-r from-[#FF6B6B] via-[#F9D876] via-40% to-[#45B7D1]" aria-hidden="true" />
          <div className="pointer-events-none absolute -right-24 -top-24 h-80 w-80 rounded-full bg-gradient-to-br from-[#FF6B6B]/30 via-[#F9D876]/20 to-[#45B7D1]/30 blur-3xl" aria-hidden="true" />

          <div className="grid items-center gap-12 md:grid-cols-2">
            <div>
              <p className="text-xs font-medium uppercase tracking-[0.28em] text-white/60">{t.pricing.eyebrow}</p>
              <p className="mt-6 font-display text-6xl font-medium leading-none tracking-tight md:text-7xl" data-testid="pricing-amount">
                <span className="mr-3 align-top font-sans text-lg font-light italic text-white/60 md:text-xl">{t.pricing.from}</span>
                <span className="text-rainbow">{t.pricing.amount}</span>
                <span className="ml-2 align-middle font-sans text-base font-light text-white/60 md:text-lg">{t.pricing.unit}</span>
              </p>
            </div>
            <div>
              <p className="text-base leading-relaxed text-white/75 md:text-lg">{t.pricing.desc}</p>
              <div className="mt-6 flex flex-wrap gap-2.5">
                {t.pricing.chips.map((chip) => (
                  <span key={chip} className="rounded-full border border-white/20 px-4 py-1.5 text-xs font-medium text-white/80">
                    {chip}
                  </span>
                ))}
              </div>
              <motion.button
                type="button"
                data-testid="pricing-cta"
                onClick={() => scrollToSection("#contact")}
                whileHover={{ scale: 1.04 }}
                whileTap={{ scale: 0.97 }}
                className="group mt-8 inline-flex items-center gap-3 rounded-full bg-[#FDFBF7] px-7 py-3.5 text-sm font-medium text-[#1A1A1A] transition-colors duration-300 hover:bg-white"
              >
                {t.pricing.cta}
                <ArrowDown className="h-4 w-4 transition-transform duration-300 group-hover:translate-y-0.5" />
              </motion.button>
            </div>
          </div>
        </div>
      </Reveal>
    </section>
  );
};

export default Pricing;
